import { api } from './client';
import type { Env } from '../types';

export function ocppCommand(env: Env, sn: string, command: string, params?: Record<string, unknown>) {
  return api(`/maintenance/${encodeURIComponent(sn)}/commands`, {
    method: 'POST',
    body: JSON.stringify({ env, command, params }),
  });
}

export function triggerOta(env: Env, sn: string, firmwareUrl?: string) {
  return api(`/maintenance/${encodeURIComponent(sn)}/ota`, {
    method: 'POST',
    body: JSON.stringify(firmwareUrl ? { env, firmwareUrl } : { env }),
  });
}

export function setRelay(env: Env, sn: string, value: 0 | 1) {
  return api(`/maintenance/${encodeURIComponent(sn)}/relay`, {
    method: 'POST',
    body: JSON.stringify({ env, value }),
  });
}
